<div [ngClass]="[groupClass]"><ng-content></ng-content></div>
